import { ITestCase } from "./ITestCase";
import { getGarconUrl, randomString } from "../Utils";
import { Features, Services } from "./Modules";
import { KaldunTicketsClient } from "../generated/submodules/garcon-api/TicketsServiceClientPb";
import { checkConnectionToSignallingServer, checkGarconUrl, checkTicket, tryFetchTicket } from "./Utils";
import KaldunTicketSubject from "../client/TicketSubject";


export default class WebSocketToSignallingServerInPushToTalk implements ITestCase {
    readonly tags: Set<string> = new Set([
        Features.PushToTalk,
        Services.Garcon,
        Services.Kvashanina,
        Services.Kaldun,
    ]);
    readonly name: string = "Connect to rtc-kaldun with push to talk tickets";

    async callback(assert: Assert): Promise<void> {
        const garconUrl = checkGarconUrl(assert, await getGarconUrl());

        const client = new KaldunTicketsClient(garconUrl);

        const subjects = [
            KaldunTicketSubject.Listen,
            KaldunTicketSubject.Talk,
            KaldunTicketSubject.TalkAndListen,
        ];

        for (let subject of subjects) {
            const accountId = randomString();
            const clientId = randomString();
            const roomId = randomString();

            const ticket = await tryFetchTicket(client, {
                accountId,
                clientId,
                roomId,
                subject,
            });

            checkTicket(assert, {
                ticket: ticket?.getTicket(),
                accountId,
                clientId,
                roomId,
                subject,
            });

            if (!ticket) {
                return;
            }
            
            await checkConnectionToSignallingServer(assert, ticket, subject);
        }
    }
}